import React from "react";
import ProjectLanding from "view/projectLanding";

const ProjectDetail = () => {

  return (
    <>
      <ProjectLanding />
    </>
  );
};

export default ProjectDetail;
